var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { h } from 'preact';
import { useState } from 'preact/hooks';
import styles from './QuickShopButton.module.scss';
import { addVariantToShopifyThemeCart } from '../../utils/shopifyThemeCart';
export function QuickShopButton({ onClick, sizeVariants = [], onAddedToCart }) {
    const [addingVariantId, setAddingVariantId] = useState(null);
    const stopBubble = (event) => {
        event.stopPropagation();
    };
    const handleAddSize = (event, variantId) => __awaiter(this, void 0, void 0, function* () {
        event.preventDefault();
        event.stopPropagation();
        if (addingVariantId !== null)
            return;
        setAddingVariantId(variantId);
        try {
            yield addVariantToShopifyThemeCart(variantId);
            onAddedToCart === null || onAddedToCart === void 0 ? void 0 : onAddedToCart(variantId);
        }
        catch (err) {
            console.error('Add to cart error:', err);
        }
        finally {
            setAddingVariantId(null);
        }
    });
    // A product with only one available size skips size selection entirely —
    // the CTA becomes "Add To Cart" and adds that variant straight away.
    const availableSizeVariants = sizeVariants.filter(variant => variant.id != null && variant.available !== false);
    const singleAvailableVariant = availableSizeVariants.length === 1 ? availableSizeVariants[0] : null;
    if (singleAvailableVariant) {
        const variantId = singleAvailableVariant.id;
        const isAdding = addingVariantId === variantId;
        return (h("div", { class: styles.sizeVariantsWrapper },
            h("div", { class: styles.quickShopAnchor },
                h("button", { type: "button", class: styles.quickShopButton, disabled: isAdding, onClick: e => handleAddSize(e, variantId) }, isAdding ? 'Adding...' : 'Add To Cart'))));
    }
    return (h("div", { class: styles.sizeVariantsWrapper },
        h("div", { class: styles.quickShopAnchor },
            h("button", { type: "button", class: styles.quickShopButton }, "Select Size"),
            h("div", { class: styles.sizeVariants }, sizeVariants.length > 0
                ? sizeVariants.map(variant => {
                    const available = variant.available !== false;
                    const href = variant.url != null && variant.url !== ''
                        ? `/products/${variant.url}${variant.id ? `?variant=${variant.id}` : ''}`
                        : undefined;
                    if (variant.id != null && available) {
                        return (h("button", { type: "button", key: variant.size, class: styles.sizeVariant, disabled: addingVariantId !== null, onClick: e => handleAddSize(e, variant.id) }, variant.size));
                    }
                    if (variant.id != null && !available) {
                        return (h("button", { type: "button", key: variant.size, class: styles.sizeVariant, disabled: true }, variant.size));
                    }
                    return href ? (h("a", { class: styles.sizeVariant, href: href, key: variant.size, onClick: stopBubble }, variant.size)) : (h("span", { class: styles.sizeVariant, key: variant.size }, variant.size));
                })
                : null))));
}
